import * as React from "react";
import PropTypes from 'prop-types';

const SvgArrowRight = props => {
  if (props.id !== "_svgarrowright") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 240 240" {...props}><path d="M72.95 224.1a9.972 9.972 0 01-7.071-2.929c-3.905-3.905-3.905-10.237 0-14.143l87.028-87.029-87.028-87.028c-3.905-3.905-3.905-10.237 0-14.143 3.905-3.904 10.237-3.905 14.143 0l94.1 94.099c3.905 3.905 3.905 10.237 0 14.143l-94.1 94.101a9.975 9.975 0 01-7.072 2.929z" /></svg>;
};

SvgArrowRight.displayName = "_svgarrowright";
SvgArrowRight.propTypes = {
  id: PropTypes.string
};
SvgArrowRight.defaultProps = {
  id: ''
};
export default SvgArrowRight;